export const GAME_CONFIG = {
  boardWidth: 40,
  boardHeight: 20,
  maxBullets: 5,
  alienPoints: 100,
  initialLives: 3,
  alienRows: 3,
  aliensPerRow: 8,
  alienSpacing: 4,
  playerChar: '^',
  alienChar: '👾',
  bulletChar: '|',
  emptyChar: ' ',
};
